'use strict';
$(document).ready(function () {
    if($('.form-edit-button').length > 0){
        $('.form-edit-button').not('#change_password_in_profile').on('click', function(elem){
            $(this).hide();
            $(this).closest('.form-item').find('input, select').not('.date-birth').removeAttr('disabled');
            $(this).closest('.form-item').find('select').trigger('chosen:updated');
            $(this).closest('.form-item').find('.btn-submit-wrap').show();
        });
    }

    if ($(".article-list.archive").length > 0) {
        if ($('nav.pagination a[rel=next]').length > 0) {
            $(".article-list.archive").infiniteScroll({path: "nav.pagination a[rel=next]", hideNav: 'nav.pagination', append: '.article-list li', history: 'disabled'});
        }
        $('nav.pagination').hide();
    }

    if ($('.catalog').length > 0) {
        $('.catalog').on('click', '.main_product .do_minus', function () {
            var new_value = parseInt($(this).parent().find('.weight-widget__value').val()) - 1;
            $(this).parent().find('.weight-widget__value').val(new_value);
        });
        $('.catalog').on('click', '.main_product .do_plus', function () {
            var new_value = parseInt($(this).parent().find('.weight-widget__value').val()) + 1;
            $(this).parent().find('.weight-widget__value').val(new_value);
        });
        $('.catalog').on('click', '.main_product .add', function () {
            var id = $(this).closest('.main_product').attr('id').replace('product_', '');
            var quontity = $(this).parent().parent().find('.weight-widget__value').val();
            $.get('/add_to_cart', {id: id, quontity: quontity}, function (data) {
                $('#product_' + id + ' .product-order__button.add').hide();
                // $('#product_' + id + ' .product-order__button.remove').show();
                $('#product_' + id + ' .product-order__button.remove').css({display: 'inline-block'});

                $('#product_' + id + ' .do_plus').attr('disabled','disabled');
                $('#product_' + id + ' .do_minus').attr('disabled','disabled');
            });
        });

        $('.purchase-list').on('click', '.product_row .do_plus', function () {
            var id = $(this).closest('.product_row').attr('id').replace('incart_', '');
            var quontity = parseInt($(this).parent().find('.weight-widget__value').val()) + 1;
            $.get('/add_to_cart', {id: id, quontity: quontity}, function (data) {
            });
        });
        $('.purchase-list').on('click', '.product_row .do_minus', function () {
            var id = $(this).closest('.product_row').attr('id').replace('incart_', '');
            var quontity = parseInt($(this).parent().find('.weight-widget__value').val()) - 1;
            $.get('/add_to_cart', {id: id, quontity: quontity}, function (data) {
            });
        });
        $('.purchase-list').on('click', '.product_row .remove-product',function(){
            var id = $(this).closest('.product_row').attr('id').replace('incart_', '');
            $.get('/add_to_cart', {id: id, quontity: 0}, function (data) {
                $('#product_' + id + ' .product-order__button.add').show();
                $('#product_' + id + ' .product-order__button.remove').hide();
                $('#product_' + id + ' .do_plus').removeAttr('disabled');
                $('#product_' + id + ' .do_minus').removeAttr('disabled');
            });
        });
    }

});

function share(type, title) {
    var url = window.location.href;
    if (type == 'fb') {
        var newWin = window.open('http://www.facebook.com/sharer.php?u=' + encodeURIComponent(window.location.href), 'fb', 'width=600,height=300,resizable=no,scrollbars=no,status=no');
    } else if (type == 'tw') {
        var newWin = window.open('http://twitter.com/share?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(url), 'tw', 'width=600,height=300,resizable=no,scrollbars=no,status=no');
    } else if (type == 'pt') {
        var newWin = window.open('http://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url) + '&description=' + title, 'pt', 'width=600,height=600,resizable=no,scrollbars=no,status=no');
    } else if (type == 'gp') {
        var newWin = window.open('https://plus.google.com/share?url=' + encodeURIComponent(url), 'gp', 'width=600,height=600,resizable=true,scrollbars=no,status=no');
    }
    newWin.focus();
}